<section *ngIf="activities">
  <app-attendee-activity-collection
    [activities]="activities"
    [description]="section.section_informations.description"
    [isLive]="section.is_live"
    [title]="section.section_informations.title"
    [parameters]="parameters"
    [seeMore]="section.see_more"
  >
  </app-attendee-activity-collection>
</section>
